import React, { useState, useMemo, useEffect } from 'react';
import './Auth.css'; // Reusing the same CSS
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { signUp } from '../../Authentication Services/AuthService';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import PopupModal from '../../Components/PopUp/PopUp';
import { TERMS_HTML_GB } from './Terms-en-GB';
import { DPA_HTML_GB } from './GDPR-en-GB';
import { TERMS_HTML_ES } from './Terms-es';
import { DPA_HTML_ES } from './GDPR-es';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';
import brandMark from '../../assets/brand-mark.png';

const Register = () => {
  const { t } = useTranslation('auth');

  // --- Language select: keep only the language CODE in state ---
  const [selectedLanguage, setSelectedLanguage] = useState(
    i18n.language?.startsWith('es') ? 'es' : 'en-GB'
  );

  // Labels are generated from translations so they update as soon as the language changes
  const languageOptions = useMemo(
    () => [
      { value: 'en-GB', label: t('register.language.english') },
      { value: 'es', label: t('register.language.spanish') }
    ],
    [t, i18n.language]
  );

  // Derive the option object from the code
  const selectedLangOption = useMemo(
    () => languageOptions.find(o => o.value === selectedLanguage) || languageOptions[0],
    [languageOptions, selectedLanguage]
  );

  // If i18n changes elsewhere, sync the code here too
  useEffect(() => {
    const code = i18n.language?.startsWith('es') ? 'es' : 'en-GB';
    if (code !== selectedLanguage) setSelectedLanguage(code);
  }, [i18n.language]); // eslint-disable-line react-hooks/exhaustive-deps
  // -------------------------------------------------------------

  const [showPassword, setShowPassword] = useState(false);
  const [showRetype, setShowRetype] = useState(false);
  const [email, setEmail] = useState('');
  const [barberShopName, setBarberShopName] = useState('');
  const [isRegisterButtonLoading, setIsRegisterButtonLoading] = useState(false);

  const errorsObj = { email: '', password: '', confirmPassword: '', barberShopName: '' };
  const [errors, setErrors] = useState(errorsObj);

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [selectedTimeZone, setSelectedTimeZone] = useState({ value: 'Europe/London', label: 'London' });

  const navigate = useNavigate();

  const [showPopup, setShowPopup] = useState(false);
  const [popUpTitle, setPopUpTitle] = useState();
  const [id, setId] = useState()
  const [popUpMessage, setPopUpMessage] = useState();
  const [popUpCancelButton, setPopUpCancelButton] = useState(false);
  const [popUpOkayButton, setPopUpOkayButton] = useState(false);

  const [showTos, setShowTos] = useState(false);
  const [showDpa, setShowDpa] = useState(false);

  const timeZoneOptions = [];
  Intl.supportedValuesOf('timeZone').forEach((timeZone) => {
    const parts = timeZone.split('/');
    timeZoneOptions.push({ value: timeZone, label: parts[1] || parts[0] });
  });

  const supported = (i18n.options?.supportedLngs || ['en', 'es']).filter(l => l !== 'cimode');
  const [lang, setLang] = useState(i18n.language);
  function ValidateSignUpData() {
    let error = false;
    const errorObjNew = { ...errorsObj };

    if (email === '') {
      errorObjNew.email = t('register.validation.emailRequired');
      error = true;
    }

    if (password === '') {
      errorObjNew.password = t('register.validation.passwordRequired');
      error = true;
    } else if (password.length < 8) {
      errorObjNew.password = t('register.validation.passwordMin');
      error = true;
    }

    if (confirmPassword === '') {
      errorObjNew.confirmPassword = t('register.validation.confirmRequired');
      error = true;
    } else if (password !== confirmPassword) {
      errorObjNew.confirmPassword = t('register.validation.passwordMismatch');
      error = true;
    }

    if (barberShopName === '') {
      errorObjNew.barberShopName = t('register.validation.businessRequired');
      error = true;
    }

    setErrors(errorObjNew);
    return error;
  }

  function onSignUp(e) {
    e.preventDefault();
    const hasError = ValidateSignUpData();
    if (hasError) return;

    setIsRegisterButtonLoading(true);

    // send the language CODE
    signUp(email, password, barberShopName, selectedTimeZone.value, selectedLanguage)
      .then((data) => {
        setPopUpTitle(t('register.popup.createdTitle'));
        setPopUpMessage('');
        setPopUpOkayButton(true);
        setPopUpCancelButton(false);
        setBarberShopName('');
        setEmail('');
        setPassword('');
        setConfirmPassword('');
        setSelectedTimeZone({ value: 'Europe/London', label: 'London' });
        navigate('/choose-plan?userId='+data.data)
      })
      .catch((error) => {
        if (error.status === 409) {
          setPopUpMessage(t('register.popup.emailExists'));
        }
        else if (error.status === 403) {
          setPopUpMessage(t('register.popup.emailNotAllowed'));
        }
        else {
          setPopUpMessage(t('register.popup.createFailed'));
        }
        setPopUpTitle(t('register.popup.errorTitle'));
        setPopUpOkayButton(false);
        setPopUpCancelButton(true);
        setShowPopup(true);
      })
      .finally((data) => {

        setIsRegisterButtonLoading(false);
      });
  }

  const handlePopupResult = (response) => {
    setShowPopup(false);
    if (response === 'ok') navigate('/login');
  };

  return (
    <div className="login-background">
      <div className="login-container">
                  <div style={{display:"flex", justifyContent:"flex-end"}}>
            <label htmlFor="lang-switch" className="visually-hidden">
              {t('login.lang.ariaLabel')}
            </label>
                <div className="centered-select">
            </div>
            <select
              id="lang-switch"
              value={lang}
              onChange={(e) => {i18n.changeLanguage(e.target.value); setLang(e.target.value); localStorage.setItem('ui.lang', e.target.value);}}
              aria-label={t('login.lang.ariaLabel')}
              className="lang-select"
              style={{
                
                padding: '6px 10px',
                borderRadius: 6,
                border: '1px solid #ddd',
                background: '#fff'
              }}
            >
              {supported.map(code => (
                <option key={code} value={code}>
                  {t(`login.lang.names.${code}`, code.toUpperCase())}
                </option>
              ))}
            </select>
          </div>
        <img src={brandMark} alt="" className="login-brand-mark" />
        <h2 className="login-title">{t('register.title')}</h2>
        <p className="login-subtitle">{t('register.subtitle')}</p>

        <form className="login-form">
          <label htmlFor="business">{t('register.business.label')}</label>
          <input
            type="text"
            id="business"
            placeholder={t('register.business.placeholder')}
            value={barberShopName}
            onChange={(e) => setBarberShopName(e.target.value)}
          />
          {errors.barberShopName && <div className="form-error">{errors.barberShopName}</div>}

          <label htmlFor="email">{t('register.email.label')}</label>
          <input
            type="email"
            id="email"
            placeholder={t('register.email.placeholder')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {errors.email && <div className="form-error">{errors.email}</div>}

          <label htmlFor="password">{t('register.password.label')}</label>
          <div className="password-wrapper">
            <input
              type={showPassword ? 'text' : 'password'}
              id="password"
              placeholder={t('register.password.placeholder')}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              type="button"
              className="eye-button"
              onClick={() => setShowPassword(!showPassword)}
              aria-label={t('register.password.toggleAria')}
            >
              {showPassword ? <FaEyeSlash className="eye-icon" /> : <FaEye className="eye-icon" />}
            </button>
          </div>
          {errors.password && <div className="form-error">{errors.password}</div>}

          <label htmlFor="retype-password">{t('register.confirm.label')}</label>
          <div className="password-wrapper">
            <input
              type={showRetype ? 'text' : 'password'}
              id="retype-password"
              placeholder={t('register.confirm.placeholder')}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <button
              type="button"
              className="eye-button"
              onClick={() => setShowRetype(!showRetype)}
              aria-label={t('register.confirm.toggleAria')}
            >
              {showRetype ? <FaEyeSlash className="eye-icon" /> : <FaEye className="eye-icon" />}
            </button>
          </div>
          {errors.confirmPassword && <div className="form-error">{errors.confirmPassword}</div>}

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '1rem',
            }}
          >
            <div>
              <label htmlFor="timezone">{t('register.timezone.label')}</label>
              <Select
                isSearchable={false}
                id="timezone"
                placeholder={t('register.timezone.placeholder')}
                closeMenuOnSelect
                options={timeZoneOptions}
                value={selectedTimeZone}
                onChange={(e) => setSelectedTimeZone({ value: e.value, label: e.label })}
                className="react-select"
                classNamePrefix="timezone-select"
              />
            </div>

            <div>
              <label htmlFor="lang">{t('register.language.label')}</label>
              <Select
                isSearchable={false}
                id="lang"
                placeholder="language"
                closeMenuOnSelect
                options={languageOptions}
                value={selectedLangOption} // fully controlled; updates instantly
                onChange={(opt) => {
                  const code = opt?.value || 'en-GB';
                  setSelectedLanguage(code);
                  i18n.changeLanguage(code);
                }}
                className="react-select"
                classNamePrefix="timezone-select"
              />
            </div>
          </div>

          <button className="signin-btn" onClick={onSignUp} disabled={isRegisterButtonLoading}>
            {isRegisterButtonLoading ? <span className="loader" /> : t('register.actions.submit')}
          </button>

          <p className="policy-text">
            {t('register.policy.prefix')}{' '}
            <button type="button" className="policy-link" onClick={() => setShowTos(true)}>
              {t('register.policy.terms')}
            </button>{' '}
            {t('register.policy.and')}{' '}
            <button type="button" className="policy-link" onClick={() => setShowDpa(true)}>
              {t('register.policy.dpa')}
            </button>
            .
          </p>
        </form>

        <div className="login-footer">
          <a href="/login">{t('register.links.signInInstead')}</a>
          <a href="/">{t('register.links.discoverMore')}</a>
        </div>
      </div>

      <PopupModal
        isOpen={showPopup}
        title={popUpTitle}
        message={popUpMessage}
        showOk={popUpOkayButton}
        showCancel={popUpCancelButton}
        onClose={handlePopupResult}
      />

      {showTos && (
        <div className="policy-modal-overlay" role="dialog" aria-modal="true" onClick={() => setShowTos(false)}>
          <div className="policy-modal" onClick={(e) => e.stopPropagation()}>
            <div className="policy-modal__header">
              <h3>{t('register.modals.terms.title')}</h3>
              <button className="policy-close" onClick={() => setShowTos(false)} aria-label={t('register.modals.closeAria')}>
                ×
              </button>
            </div>
            <div className="policy-modal__body" dangerouslySetInnerHTML={{ __html: lang === "en" ? TERMS_HTML_GB : lang === "es" ? TERMS_HTML_ES : TERMS_HTML_GB }} />
            <div className="policy-modal__actions">
              <button className="btn-neutral" onClick={() => setShowTos(false)}>
                {t('register.modals.close')}
              </button>
            </div>
          </div>
        </div>
      )}

      {showDpa && (
        <div className="policy-modal-overlay" role="dialog" aria-modal="true" onClick={() => setShowDpa(false)}>
          <div className="policy-modal" onClick={(e) => e.stopPropagation()}>
            <div className="policy-modal__header">
              <h3>{t('register.modals.dpa.title')}</h3>
              <button className="policy-close" onClick={() => setShowDpa(false)} aria-label={t('register.modals.closeAria')}>
                ×
              </button>
            </div>
            <div className="policy-modal__body" dangerouslySetInnerHTML={{ __html: lang === "en" ? DPA_HTML_GB : lang === "es" ? DPA_HTML_ES : DPA_HTML_GB }} />
            <div className="policy-modal__actions">
              <button className="btn-neutral" onClick={() => setShowDpa(false)}>
                {t('register.modals.close')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Register;
